export interface QueryField {
  name: string;
  isNullable: boolean;
  isSortable: boolean;
  isSearchable?: boolean;
  type: string;
}

export enum SortOrder {
  ASC = 'asc',
  DESC = 'desc',
}

export interface TimeInterval {
  duration: number;
  period: string;
}

export type TimeIntervalDropdown = {
  label: string;
  value: string;
};

export const timeIntervalOptions = [
  { label: 'Last 15 minutes', value: '15m' },
  { label: 'Last 30 minutes', value: '30m' },
  { label: 'Last 12 hours', value: '12h' },
  { label: 'Last 24 hours', value: '24h' },
  { label: 'Last 7 days', value: '7d' },
  { label: 'Last 15 days', value: '15d' },
  // 30 days === 1 month in postgres
  { label: 'Last 30 days', value: '30d' },
  { label: 'Last 6 months', value: '6M' },
  { label: 'Custom date range', value: 'custom' },
];

export interface DehydratedMetadata {
  sortOrder: SortOrder;
  sortField: string;
  time: {
    timeInterval: TimeInterval;
    upperTimeInterval?: TimeInterval;
  };
}

export enum TimePeriod {
  Minutes = 'minutes',
  Hours = 'hours',
  Days = 'days',
  Months = 'months',
}

export enum AnalyticsQueryParams {
  TimeInterval = 'ti',
  UpperTimeInterval = 'uti',
  Timestamp = 'ts',
  UpperTimestamp = 'uts',
  Filters = 'f',
  SortField = 'sf',
  SortOrderField = 'so',
  QueryField = 'qf',
  Query = 'q',
}

export type QueryParamUrlObject = Record<AnalyticsQueryParams | string, string>;

export interface DehydratedAnalyticsQuery {
  id: string;
  metadata: DehydratedMetadata;
  fields: QueryField[];
  executedAt: number;
  rows: unknown[][];
}

export interface QueryMetadata {
  sortOrder: SortOrder;
  sortField?: string;
  time: {
    timeInterval?: TimeInterval;
    upperTimeInterval?: TimeInterval;
    timestamp?: number;
    upperTimestamp?: number;
    timestamps?: string[];
    period?: TimePeriod;
  };
}

export interface AnalyticQuery<T> {
  id: string;
  fields: QueryField[];
  metadata: QueryMetadata;
  executedAt: number;
  rows: T[];
}

// TODO: fully type up funnel step types
interface FunnelStep {
  name: string;
  eventName?: string;
}

export interface Goal {
  id: string;
  contentId: string;
  funnelStep: FunnelStep;
  name?: string;
  segmentIds?: string[];
}

export enum GraphDataType {
  Views = 'views',
  UniqueViews = 'uniqueViews',
  Interactions = 'interactions',
  Conversion = 'conversion',
  ChecklistCompleted = 'checklistCompleted',
  FormSubmitted = 'formSubmitted',
}
